// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
/**
 * Note : Under calendar.proto and schedule.proto, location_ids are child location ids.
 */
export const SchedulerService = {
    /**
     * ------------------------------------------------ Providers ------------------------------------------------
     */
    GetProvider(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/providers/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    ListProviders(fn, req) {
        return fn(`/schedule/v3/providers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListProvidersMulti(fn, req) {
        return fn(`/schedule/v3/providers/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Create a provider for non-integrated office. For integrated office provider are synced from PMS.
     */
    CreateProvider(fn, req) {
        return fn(`/schedule/v3/providers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateProvider(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/providers/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteProviders(fn, req) {
        return fn(`/schedule/v3/providers?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * For both integrated and non integrated offices, provider is associated with weave user.
     */
    AssociateProviderWithWeaveUser(fn, req) {
        return fn(`/schedule/v3/providers-user-association`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------------------------------- Appointment Types -----------------------------------------
     */
    GetAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "GET" });
    },
    ListAppointmentTypes(fn, req) {
        return fn(`/schedule/v3/appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListAppointmentTypesMulti(fn, req) {
        return fn(`/schedule/v3/appointment-types/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Create a appointment types for non-integrated office. For integrated office appointment types are synced from PMS.
     */
    CreateAppointmentType(fn, req) {
        return fn(`/schedule/v3/appointment-types`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/appointment-types/${req["appointmentTypeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteAppointmentTypes(fn, req) {
        return fn(`/schedule/v3/appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * -------------------------------------------- Schedule ---------------------------------------------
     */
    ListSchedules(fn, req) {
        return fn(`/schedule/v3/schedules?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateSchedule(fn, req) {
        return fn(`/schedule/v3/schedules`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateSchedule(fn, req) {
        return fn(`/schedule/v3/schedules`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteSchedules(fn, req) {
        return fn(`/schedule/v3/schedules?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * --------------------------------------------------- Mappings ---------------------------------------------------
     */
    ListMappings(fn, req) {
        return fn(`/schedule/v3/mappings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateMappings(fn, req) {
        return fn(`/schedule/v3/mappings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteMappings(fn, req) {
        return fn(`/schedule/v3/mappings?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * ------------------------------------------------ Calendars ------------------------------------------------
     */
    ListCalendars(fn, req) {
        return fn(`/schedule/v3/calendars?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarsByOwner(fn, req) {
        try {
            fm.validateUrlParam(req["ownerId"], "ownerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/owners/${req["ownerId"]}?${fm.renderURLSearchParams(req, ["ownerId"])}`, { method: "GET" });
    },
    GetCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "GET" });
    },
    CreateCalendar(fn, req) {
        return fn(`/schedule/v3/calendars`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteCalendar(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "DELETE" });
    },
    ListCalendarAvailabilities(fn, req) {
        try {
            fm.validateUrlParam(req["calendarId"], "calendarId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/${req["calendarId"]}/availabilities?${fm.renderURLSearchParams(req, ["calendarId"])}`, { method: "GET" });
    },
    /**
     * ---------------------------------------------- Operatories ----------------------------------------------
     */
    GetOperatory(fn, req) {
        try {
            fm.validateUrlParam(req["operatoryId"], "operatoryId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/operatories/${req["operatoryId"]}?${fm.renderURLSearchParams(req, ["operatoryId"])}`, { method: "GET" });
    },
    ListOperatories(fn, req) {
        return fn(`/schedule/v3/operatories?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListOperatoriesMulti(fn, req) {
        return fn(`/schedule/v3/operatories/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Create a operatory for non-integrated office. For integrated office operatories are synced from PMS.
     */
    CreateOperatory(fn, req) {
        return fn(`/schedule/v3/operatories`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateOperatory(fn, req) {
        try {
            fm.validateUrlParam(req["operatoryId"], "operatoryId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/operatories/${req["operatoryId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteOperatories(fn, req) {
        return fn(`/schedule/v3/operatories?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * ------------------------------------------------ CalendarEvents ------------------------------------------------
     */
    GetCalendarEvent(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}?${fm.renderURLSearchParams(req, ["eventId"])}`, { method: "GET" });
    },
    ListCalendarEvents(fn, req) {
        return fn(`/schedule/v3/calendars/events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarEventsMulti(fn, req) {
        return fn(`/schedule/v3/calendars/events/multi?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarEventsByOwner(fn, req) {
        try {
            fm.validateUrlParam(req["ownerId"], "ownerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/owners/${req["ownerId"]}/events?${fm.renderURLSearchParams(req, ["ownerId"])}`, { method: "GET" });
    },
    CreateCalendarEvent(fn, req) {
        return fn(`/schedule/v3/calendars/events`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarEvent(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarEventStatus(fn, req) {
        try {
            fm.validateUrlParam(req["eventId"], "eventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/${req["eventId"]}/status`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteCalendarEvents(fn, req) {
        return fn(`/schedule/v3/calendars/events?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * Retrieves all appointments for a specific attendee, paginated by cursor.
     * Results are sorted in descending order of start date (most recent or upcoming first).
     * Pagination navigates backward in time with each page.
     * To optimize performance, the query is limited to appointments within the past 10 years and up to 1 year in the future.
     */
    ListCalendarEventsByAttendee(fn, req) {
        try {
            fm.validateUrlParam(req["attendeeId"], "attendeeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/calendars/events/attendee/${req["attendeeId"]}?${fm.renderURLSearchParams(req, ["attendeeId"])}`, { method: "GET" });
    },
    /**
     * ------------------------------------------------ Writebacks ------------------------------------------------
     */
    AppointmentWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/appointment`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *
     * UpdateAppointment write backs the appointment status and other details to the PMS.
     */
    UpdateAppointment(fn, req) {
        return fn(`/schedule/v3/write-backs/appointment`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    AppointmentStatusWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/appointment-status`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    PersonWriteBack(fn, req) {
        return fn(`/schedule/v3/write-backs/person`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ------------------------------------------------ Source Tenants ------------------------------------------------
     */
    ListSourceTenants(fn, req) {
        return fn(`/schedule/v3/source-tenants?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetPreferredSourceTenant(fn, req) {
        return fn(`/schedule/v3/source-tenants/preferred`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    RefreshSourceTenants(fn, req) {
        return fn(`/schedule/v3/source-tenants/refresh`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ------------------------------------------------ Booking Submissions ----------------------------------------------
     */
    ListBookingSubmissions(fn, req) {
        return fn(`/schedule/v3/booking-submissions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetBookingSubmission(fn, req) {
        try {
            fm.validateUrlParam(req["submissionId"], "submissionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/booking-submissions/${req["submissionId"]}?${fm.renderURLSearchParams(req, ["submissionId"])}`, { method: "GET" });
    },
    CreateBookingSubmission(fn, req) {
        return fn(`/schedule/v3/booking-submissions`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateBookingSubmission(fn, req) {
        try {
            fm.validateUrlParam(req["submissionId"], "submissionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/booking-submissions/${req["submissionId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteBookingSubmission(fn, req) {
        return fn(`/schedule/v3/booking-submissions?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * ------------------------------------------------ Settings ------------------------------------------------
     */
    CreateLocationSettings(fn, req) {
        return fn(`/schedule/v3/settings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateLocationSettings(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/v3/settings/${req["locationId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListLocationSettings(fn, req) {
        return fn(`/schedule/v3/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    FeatureFlagStatus(fn, req) {
        return fn(`/schedule/v3/settings/feature-flag/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ReadinessCheck reports if an organization and all the locations that are a
     * part of that organization are ready to be on the v3 scheduler. This accepts
     * a location_id or organization_id not both. If a location_id is provided the
     * organization that location belongs to will be used for the check.
     */
    ReadinessCheck(fn, req) {
        return fn(`/schedule/v3/settings/ready?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PublicReadinessCheck is the unauthenticated version of ReadinessCheck. This
     * performs the same checks but returns a simplified response.
     */
    PublicReadinessCheck(fn, req) {
        return fn(`/schedule/v3/settings/ready/public?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ------------------------------------------------ Availability ----------------------------------------------
     */
    ListAvailabilities(fn, req) {
        return fn(`/schedule/v3/availabilities?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
